export default __webpack_public_path__ + "static/media/025.df4ed3a3.jpg";